import { Spinner } from "react-bootstrap"
import RegistrosRondaMapa from "./RegistrosRondaMapa"
import styles from "./styles.module.css";

export default function QrCodeRondaMapaPainelMapa({ registrosRonda, loading }:iProps) { 
    return (
        <div id={styles.painel_mapa}>
            {loading && <div className="div-row" style={{width: "100%", height: "100%", justifyContent: "center"}}>
                <Spinner animation="border" role="status"></Spinner>
            </div>}
            {!loading && <RegistrosRondaMapa registros={registrosRonda} />}
        </div>
    )
}
interface iProps { 
    registrosRonda: any[]
    loading: boolean
}
